module.exports = __webpack_public_path__ + "media/images/altruism-segment-c193949a8480634490da6bb0864d7b05.jpg";